import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { platformBlocksRu } from "@/shared/i18n";

/**
 * Админка целиком русская и переводы с бэкенда не тянет (в отличие от
 * партнёрского кабинета, см. `partner/app/providers/i18n.ts`). Но общие
 * компоненты из `shared` (редактор блоков страниц PlatformBlocks) ходят за
 * текстами через `useTranslation()`, а без инициализированного инстанса
 * i18next `t` возвращает сам ключ. Поэтому здесь поднимается минимальный
 * инстанс с локальными русскими ресурсами: ни HttpBackend, ни переключения
 * языка, ни saveMissing.
 */
i18n.use(initReactI18next).init({
  lng: "ru",
  fallbackLng: "ru",
  supportedLngs: ["ru"],
  ns: ["admin"],
  defaultNS: "admin",
  interpolation: { escapeValue: false },
  returnEmptyString: false,
  resources: {
    ru: {
      admin: {
        platformBlocks: platformBlocksRu,
      },
    },
  },
});

// eslint-disable-next-line import/no-default-export
export default i18n;
